import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type QuotePayload = any;

interface QuoteListState {
  advancedQuoteslist: QuotePayload[]; // Advanced quotes
  basicQuotesList: QuotePayload[]; // Basic quotes
}

const initialState: QuoteListState = {
  advancedQuoteslist: [],
  basicQuotesList: [],
};

export const quoteListSlice = createSlice({
  name: "quoteList",
  initialState,
  reducers: {
    // --- ADVANCED QUOTES ---
    addAdvancedQuoteList: (state, action: PayloadAction<QuotePayload>) => {
      state.advancedQuoteslist.push({
        ...action.payload,
        id: crypto.randomUUID(),
      });
    },

    updateAdvancedQuoteList: (state, action) => {
      const { id, updates } = action.payload;
      const index = state.advancedQuoteslist.findIndex((q) => q.id === id);
      if (index !== -1) {
        state.advancedQuoteslist[index] = {
          ...state.advancedQuoteslist[index],
          ...updates,
        };
      }
    },

    updateQuote: (state, action: PayloadAction<{ index: number; updates: any }>) => {
      const { index, updates } = action.payload;
      if (state.advancedQuoteslist[index]) {
        state.advancedQuoteslist[index] = {
          ...state.advancedQuoteslist[index],
          ...updates,
        };
      }
    },

    removeQuote: (state, action: PayloadAction<number>) => {
      state.advancedQuoteslist.splice(action.payload, 1);
    },

    removeAdvancedQuote: (state, action: PayloadAction<string>) => {
      state.advancedQuoteslist = state.advancedQuoteslist?.filter(
        quote => quote.id !== action.payload
      );
    },


    clearQuotes: (state) => {
      state.advancedQuoteslist = [];
      state.basicQuotesList = [];
    },

    // --- BASIC QUOTES ---
    addBasicQuote: (state, action: PayloadAction<QuotePayload>) => {
      state.basicQuotesList.push(action.payload);
    },

    updateBasicQuote: (state, action: PayloadAction<{ index: number; updates: any }>) => {
      const { index, updates } = action.payload;
      if (state.basicQuotesList[index]) {
        state.basicQuotesList[index] = {
          ...state.basicQuotesList[index],
          ...updates,
        };
      }
    },

    removeBasicQuote: (state, action: PayloadAction<number>) => {
      state.basicQuotesList.splice(action.payload, 1);
    },

    clearBasicQuotes: (state) => {
      state.basicQuotesList = [];
    },
  },
});

export const {
  addAdvancedQuoteList,
  updateQuote,
  updateAdvancedQuoteList,
  removeQuote,
  removeAdvancedQuote,
  clearQuotes,

  addBasicQuote,
  updateBasicQuote,
  removeBasicQuote,
  clearBasicQuotes,
} = quoteListSlice.actions;

export default quoteListSlice.reducer;

// --- SELECTORS ---
export const selectQuoteList = (state: any) => state.quoteList.advancedQuoteslist;
export const selectBasicQuoteList = (state: any) => state.quoteList.basicQuotesList;
